/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DboV1Account } from '../models';
// @ts-ignore
import type { DboV1CacheConfiguration } from '../models';
// @ts-ignore
import type { DboV1CacheGroup } from '../models';
// @ts-ignore
import type { DboV1CacheQuery } from '../models';
// @ts-ignore
import type { DboV1CreateCacheDiagnosticUploadURLResponse } from '../models';
// @ts-ignore
import type { DboV1DatabaseCluster } from '../models';
// @ts-ignore
import type { DboV1DatabaseInstance } from '../models';
// @ts-ignore
import type { DboV1ExchangeCacheStateResponse } from '../models';
// @ts-ignore
import type { DboV1GetCacheConfigurationResponse } from '../models';
// @ts-ignore
import type { DboV1GetCacheEfficiencyResponse } from '../models';
// @ts-ignore
import type { DboV1GetCacheGroupMetricsFilterOptionsResponse } from '../models';
// @ts-ignore
import type { DboV1GetCacheGroupOperationalMetricsResponse } from '../models';
// @ts-ignore
import type { DboV1GetCacheGroupPerformanceResponse } from '../models';
// @ts-ignore
import type { DboV1GetCacheGroupPerformanceSummaryResponse } from '../models';
// @ts-ignore
import type { DboV1GetCacheGroupPoolingEligibilityResponse } from '../models';
// @ts-ignore
import type { DboV1GetCacheQueriesResponse } from '../models';
// @ts-ignore
import type { DboV1GetCacheQueryInsightsResponse } from '../models';
// @ts-ignore
import type { DboV1GetCacheQueryTemplateResponse } from '../models';
// @ts-ignore
import type { DboV1GetCacheSummaryResponse } from '../models';
// @ts-ignore
import type { DboV1InstanceMetrics } from '../models';
// @ts-ignore
import type { DboV1ListCacheConfigurationsResponse } from '../models';
// @ts-ignore
import type { DboV1ListCacheGroupsResponse } from '../models';
// @ts-ignore
import type { DboV1ListCacheTTLsResponse } from '../models';
// @ts-ignore
import type { DboV1ListDatabaseComponentsResponse } from '../models';
// @ts-ignore
import type { DboV1OperationalMetrics } from '../models';
// @ts-ignore
import type { DboV1ProxyState } from '../models';
// @ts-ignore
import type { DboV1Registration } from '../models';
// @ts-ignore
import type { DboV1RegistrationStatusUpdate } from '../models';
// @ts-ignore
import type { DboV1TTLConfiguration } from '../models';
// @ts-ignore
import type { GoogleApiHttpBody } from '../models';
/**
 * DboAPIApi - axios parameter creator
 * @export
 */
export const DboAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates new cache configuration in a given cache group.
         * @summary Create cache configuration
         * @param {string} groupId 
         * @param {DboV1CacheConfiguration} config 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPICreateCacheConfiguration: async (groupId: string, config: DboV1CacheConfiguration, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('dboAPICreateCacheConfiguration', 'groupId', groupId)
            // verify required parameter 'config' is not null or undefined
            assertParamExists('dboAPICreateCacheConfiguration', 'config', config)
            const localVarPath = `/v1/dbo/cache-groups/{groupId}/cache-configurations`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(config, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates an ephemeral upload URL for a diagnostics file
         * @summary Create upload URL for diagnostic file
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPICreateCacheDiagnosticUploadURL: async (groupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('dboAPICreateCacheDiagnosticUploadURL', 'groupId', groupId)
            const localVarPath = `/v1/dbo/cache-groups/{groupId}/diagnostics/upload-url`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates new cache group.
         * @summary Create cache group.
         * @param {DboV1CacheGroup} group 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPICreateCacheGroup: async (group: DboV1CacheGroup, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'group' is not null or undefined
            assertParamExists('dboAPICreateCacheGroup', 'group', group)
            const localVarPath = `/v1/dbo/cache-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(group, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates new cache TTL configuration.
         * @summary Create cache TTL configuration
         * @param {string} groupId 
         * @param {string} id 
         * @param {DboV1TTLConfiguration} config 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPICreateCacheTTL: async (groupId: string, id: string, config: DboV1TTLConfiguration, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('dboAPICreateCacheTTL', 'groupId', groupId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dboAPICreateCacheTTL', 'id', id)
            // verify required parameter 'config' is not null or undefined
            assertParamExists('dboAPICreateCacheTTL', 'config', config)
            const localVarPath = `/v1/dbo/cache-groups/{groupId}/cache-configurations/{id}/rules`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(config, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new registration.
         * @param {DboV1Registration} registration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPICreateRegistration: async (registration: DboV1Registration, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registration' is not null or undefined
            assertParamExists('dboAPICreateRegistration', 'registration', registration)
            const localVarPath = `/v1/dbo/registrations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create registration status update.
         * @param {string} registrationId 
         * @param {DboV1RegistrationStatusUpdate} statusUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPICreateRegistrationStatusUpdate: async (registrationId: string, statusUpdate: DboV1RegistrationStatusUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registrationId' is not null or undefined
            assertParamExists('dboAPICreateRegistrationStatusUpdate', 'registrationId', registrationId)
            // verify required parameter 'statusUpdate' is not null or undefined
            assertParamExists('dboAPICreateRegistrationStatusUpdate', 'statusUpdate', statusUpdate)
            const localVarPath = `/v1/dbo/registrations/{registrationId}/status`
                .replace(`{${"registrationId"}}`, encodeURIComponent(String(registrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(statusUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes cache configuration.
         * @summary Deletes cache configuration
         * @param {string} groupId 
         * @param {string} id 
         * @param {boolean} [roxy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIDeleteCacheConfiguration: async (groupId: string, id: string, roxy?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('dboAPIDeleteCacheConfiguration', 'groupId', groupId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dboAPIDeleteCacheConfiguration', 'id', id)
            const localVarPath = `/v1/dbo/cache-groups/{groupId}/cache-configurations/{id}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (roxy !== undefined) {
                localVarQueryParameter['roxy'] = roxy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a given cache group.
         * @summary Deletes cache group.
         * @param {string} id 
         * @param {boolean} [roxy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIDeleteCacheGroup: async (id: string, roxy?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dboAPIDeleteCacheGroup', 'id', id)
            const localVarPath = `/v1/dbo/cache-groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (roxy !== undefined) {
                localVarQueryParameter['roxy'] = roxy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes TTL cache configuration.
         * @summary Deletes TTL cache configuration
         * @param {string} groupId 
         * @param {string} cacheId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIDeleteCacheTTL: async (groupId: string, cacheId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('dboAPIDeleteCacheTTL', 'groupId', groupId)
            // verify required parameter 'cacheId' is not null or undefined
            assertParamExists('dboAPIDeleteCacheTTL', 'cacheId', cacheId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dboAPIDeleteCacheTTL', 'id', id)
            const localVarPath = `/v1/dbo/cache-groups/{groupId}/cache-configurations/{cacheId}/rules/{id}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"cacheId"}}`, encodeURIComponent(String(cacheId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * State/config exchange between a proxy instance and CAST AI control plane.
         * @summary State exchange
         * @param {string} cacheGroupId 
         * @param {DboV1ProxyState} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIExchangeCacheState: async (cacheGroupId: string, state: DboV1ProxyState, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cacheGroupId' is not null or undefined
            assertParamExists('dboAPIExchangeCacheState', 'cacheGroupId', cacheGroupId)
            // verify required parameter 'state' is not null or undefined
            assertParamExists('dboAPIExchangeCacheState', 'state', state)
            const localVarPath = `/v1/dbo/cache-state-exchange/{cacheGroupId}`
                .replace(`{${"cacheGroupId"}}`, encodeURIComponent(String(cacheGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(state, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a cache configuration for a given cache group and database name
         * @summary Get cache configuration
         * @param {string} groupId 
         * @param {string} databaseName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheConfiguration: async (groupId: string, databaseName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('dboAPIGetCacheConfiguration', 'groupId', groupId)
            // verify required parameter 'databaseName' is not null or undefined
            assertParamExists('dboAPIGetCacheConfiguration', 'databaseName', databaseName)
            const localVarPath = `/v1/dbo/cache-groups/{groupId}/cache-configurations/{databaseName}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"databaseName"}}`, encodeURIComponent(String(databaseName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves cache efficiency.
         * @summary Get cache efficiency data.
         * @param {string} groupId 
         * @param {string} cacheId 
         * @param {string} startTime Start of period.
         * @param {string} endTime End of period.
         * @param {number} stepSeconds Aggregate items in specified interval steps.
         * @param {string} [templateHash] Optionally filter the results by a specific template hash
         * @param {string} [username] Filter by username.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheEfficiency: async (groupId: string, cacheId: string, startTime: string, endTime: string, stepSeconds: number, templateHash?: string, username?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('dboAPIGetCacheEfficiency', 'groupId', groupId)
            // verify required parameter 'cacheId' is not null or undefined
            assertParamExists('dboAPIGetCacheEfficiency', 'cacheId', cacheId)
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('dboAPIGetCacheEfficiency', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('dboAPIGetCacheEfficiency', 'endTime', endTime)
            // verify required parameter 'stepSeconds' is not null or undefined
            assertParamExists('dboAPIGetCacheEfficiency', 'stepSeconds', stepSeconds)
            const localVarPath = `/v1/dbo/cache-groups/{groupId}/cache-configurations/{cacheId}/efficiency`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"cacheId"}}`, encodeURIComponent(String(cacheId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (stepSeconds !== undefined) {
                localVarQueryParameter['stepSeconds'] = stepSeconds;
            }

            if (templateHash !== undefined) {
                localVarQueryParameter['templateHash'] = templateHash;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns cache group by ID.
         * @summary Get cache group.
         * @param {string} id 
         * @param {string} [metricsRangeStart] Start of period.
         * @param {string} [metricsRangeEnd] End of period.
         * @param {boolean} [roxy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheGroup: async (id: string, metricsRangeStart?: string, metricsRangeEnd?: string, roxy?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dboAPIGetCacheGroup', 'id', id)
            const localVarPath = `/v1/dbo/cache-groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (metricsRangeStart !== undefined) {
                localVarQueryParameter['metricsRange.start'] = (metricsRangeStart as any instanceof Date) ?
                    (metricsRangeStart as any).toISOString() :
                    metricsRangeStart;
            }

            if (metricsRangeEnd !== undefined) {
                localVarQueryParameter['metricsRange.end'] = (metricsRangeEnd as any instanceof Date) ?
                    (metricsRangeEnd as any).toISOString() :
                    metricsRangeEnd;
            }

            if (roxy !== undefined) {
                localVarQueryParameter['roxy'] = roxy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves available filter options (e.g., users) for cache group metrics.
         * @summary Get cache group metrics filter options
         * @param {string} id 
         * @param {string} [timeRangeStart] Start of period.
         * @param {string} [timeRangeEnd] End of period.
         * @param {string} [databaseId] Filter by specific database (cache configuration) ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheGroupMetricsFilterOptions: async (id: string, timeRangeStart?: string, timeRangeEnd?: string, databaseId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dboAPIGetCacheGroupMetricsFilterOptions', 'id', id)
            const localVarPath = `/v1/dbo/cache-groups/{id}/metrics-filter-options`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (timeRangeStart !== undefined) {
                localVarQueryParameter['timeRange.start'] = (timeRangeStart as any instanceof Date) ?
                    (timeRangeStart as any).toISOString() :
                    timeRangeStart;
            }

            if (timeRangeEnd !== undefined) {
                localVarQueryParameter['timeRange.end'] = (timeRangeEnd as any instanceof Date) ?
                    (timeRangeEnd as any).toISOString() :
                    timeRangeEnd;
            }

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves cache group operational metrics timeseries data.
         * @summary Get cache group operational metrics
         * @param {string} id 
         * @param {number} stepSeconds Aggregate items in specified interval steps.
         * @param {string} [metricsRangeStart] Start of period.
         * @param {string} [metricsRangeEnd] End of period.
         * @param {string} [configurationId] Cache configuration id: if provided, will filter by it.
         * @param {string} [endpointName] Filter by endpoint name. Cannot be combined with username.
         * @param {string} [username] Filter by username. Cannot be combined with endpoint_name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheGroupOperationalMetrics: async (id: string, stepSeconds: number, metricsRangeStart?: string, metricsRangeEnd?: string, configurationId?: string, endpointName?: string, username?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dboAPIGetCacheGroupOperationalMetrics', 'id', id)
            // verify required parameter 'stepSeconds' is not null or undefined
            assertParamExists('dboAPIGetCacheGroupOperationalMetrics', 'stepSeconds', stepSeconds)
            const localVarPath = `/v1/dbo/cache-groups/{id}/operational-metrics`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (metricsRangeStart !== undefined) {
                localVarQueryParameter['metricsRange.start'] = (metricsRangeStart as any instanceof Date) ?
                    (metricsRangeStart as any).toISOString() :
                    metricsRangeStart;
            }

            if (metricsRangeEnd !== undefined) {
                localVarQueryParameter['metricsRange.end'] = (metricsRangeEnd as any instanceof Date) ?
                    (metricsRangeEnd as any).toISOString() :
                    metricsRangeEnd;
            }

            if (stepSeconds !== undefined) {
                localVarQueryParameter['stepSeconds'] = stepSeconds;
            }

            if (configurationId !== undefined) {
                localVarQueryParameter['configurationId'] = configurationId;
            }

            if (endpointName !== undefined) {
                localVarQueryParameter['endpointName'] = endpointName;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves cache group performance timeseries data.
         * @summary Get cache group performance
         * @param {string} id 
         * @param {string} startTime Start of period.
         * @param {string} endTime End of period.
         * @param {number} stepSeconds Aggregate items in specified interval steps.
         * @param {string} [databaseId] Filter by specific database (cache configuration) ID.
         * @param {string} [endpointName] Filter by endpoint name. Cannot be combined with username.
         * @param {string} [username] Filter by username. Cannot be combined with endpoint_name.
         * @param {boolean} [roxy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheGroupPerformance: async (id: string, startTime: string, endTime: string, stepSeconds: number, databaseId?: string, endpointName?: string, username?: string, roxy?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dboAPIGetCacheGroupPerformance', 'id', id)
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('dboAPIGetCacheGroupPerformance', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('dboAPIGetCacheGroupPerformance', 'endTime', endTime)
            // verify required parameter 'stepSeconds' is not null or undefined
            assertParamExists('dboAPIGetCacheGroupPerformance', 'stepSeconds', stepSeconds)
            const localVarPath = `/v1/dbo/cache-groups/{id}/cache-performance`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (stepSeconds !== undefined) {
                localVarQueryParameter['stepSeconds'] = stepSeconds;
            }

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (endpointName !== undefined) {
                localVarQueryParameter['endpointName'] = endpointName;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (roxy !== undefined) {
                localVarQueryParameter['roxy'] = roxy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves aggregated cache performance metrics for a cache group.
         * @summary Get cache group performance summary
         * @param {string} id 
         * @param {string} [metricsRangeStart] Start of period.
         * @param {string} [metricsRangeEnd] End of period.
         * @param {string} [databaseId] Filter by specific database (cache configuration) ID.
         * @param {string} [endpointName] Filter by endpoint name. Cannot be combined with username.
         * @param {string} [username] Filter by username. Cannot be combined with endpoint_name.
         * @param {boolean} [roxy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheGroupPerformanceSummary: async (id: string, metricsRangeStart?: string, metricsRangeEnd?: string, databaseId?: string, endpointName?: string, username?: string, roxy?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dboAPIGetCacheGroupPerformanceSummary', 'id', id)
            const localVarPath = `/v1/dbo/cache-groups/{id}/cache-performance/summary`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (metricsRangeStart !== undefined) {
                localVarQueryParameter['metricsRange.start'] = (metricsRangeStart as any instanceof Date) ?
                    (metricsRangeStart as any).toISOString() :
                    metricsRangeStart;
            }

            if (metricsRangeEnd !== undefined) {
                localVarQueryParameter['metricsRange.end'] = (metricsRangeEnd as any instanceof Date) ?
                    (metricsRangeEnd as any).toISOString() :
                    metricsRangeEnd;
            }

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (endpointName !== undefined) {
                localVarQueryParameter['endpointName'] = endpointName;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (roxy !== undefined) {
                localVarQueryParameter['roxy'] = roxy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves cache group operational metrics timeseries data.
         * @summary Get cache group pooling eligibility report
         * @param {string} id Cache Group ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheGroupPoolingEligibility: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dboAPIGetCacheGroupPoolingEligibility', 'id', id)
            const localVarPath = `/v1/dbo/cache-groups/{id}/pooling-eligibility`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves cache queries for the current organization.
         * @summary Get cache queries
         * @param {string} groupId 
         * @param {string} cacheId 
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] Name of the field you want to sort
         * @param {DboAPIGetCacheQueriesSortOrderEnum} [sortOrder] The sort order, possible values ASC or DESC, if not provided asc is the default   - ASC: ASC  - asc: desc  - DESC: ASC  - desc: desc
         * @param {string} [startTime] Start of period.
         * @param {string} [endTime] End of period.
         * @param {string} [queryContains] An optional parameter for performing substring matching on the query template string.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheQueries: async (groupId: string, cacheId: string, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: DboAPIGetCacheQueriesSortOrderEnum, startTime?: string, endTime?: string, queryContains?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('dboAPIGetCacheQueries', 'groupId', groupId)
            // verify required parameter 'cacheId' is not null or undefined
            assertParamExists('dboAPIGetCacheQueries', 'cacheId', cacheId)
            const localVarPath = `/v1/dbo/cache-groups/{groupId}/cache-configurations/{cacheId}/queries`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"cacheId"}}`, encodeURIComponent(String(cacheId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort.field'] = sortField;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort.order'] = sortOrder;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (queryContains !== undefined) {
                localVarQueryParameter['queryContains'] = queryContains;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves cache query for the current organization by its template hash.
         * @summary Get cache query
         * @param {string} groupId 
         * @param {string} cacheId 
         * @param {string} templateHash 
         * @param {string} [metricsRangeStart] Start of period.
         * @param {string} [metricsRangeEnd] End of period.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheQuery: async (groupId: string, cacheId: string, templateHash: string, metricsRangeStart?: string, metricsRangeEnd?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('dboAPIGetCacheQuery', 'groupId', groupId)
            // verify required parameter 'cacheId' is not null or undefined
            assertParamExists('dboAPIGetCacheQuery', 'cacheId', cacheId)
            // verify required parameter 'templateHash' is not null or undefined
            assertParamExists('dboAPIGetCacheQuery', 'templateHash', templateHash)
            const localVarPath = `/v1/dbo/cache-groups/{groupId}/cache-configurations/{cacheId}/queries/{templateHash}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"cacheId"}}`, encodeURIComponent(String(cacheId)))
                .replace(`{${"templateHash"}}`, encodeURIComponent(String(templateHash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (metricsRangeStart !== undefined) {
                localVarQueryParameter['metricsRange.start'] = (metricsRangeStart as any instanceof Date) ?
                    (metricsRangeStart as any).toISOString() :
                    metricsRangeStart;
            }

            if (metricsRangeEnd !== undefined) {
                localVarQueryParameter['metricsRange.end'] = (metricsRangeEnd as any instanceof Date) ?
                    (metricsRangeEnd as any).toISOString() :
                    metricsRangeEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves detailed query insights such as cache miss latency, TTL values, and unique parameter counts over time.
         * @summary Get cache query insights
         * @param {string} groupId 
         * @param {string} cacheId 
         * @param {string} templateHash 
         * @param {number} stepSeconds 
         * @param {string} [metricsRangeStart] Start of period.
         * @param {string} [metricsRangeEnd] End of period.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheQueryInsights: async (groupId: string, cacheId: string, templateHash: string, stepSeconds: number, metricsRangeStart?: string, metricsRangeEnd?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('dboAPIGetCacheQueryInsights', 'groupId', groupId)
            // verify required parameter 'cacheId' is not null or undefined
            assertParamExists('dboAPIGetCacheQueryInsights', 'cacheId', cacheId)
            // verify required parameter 'templateHash' is not null or undefined
            assertParamExists('dboAPIGetCacheQueryInsights', 'templateHash', templateHash)
            // verify required parameter 'stepSeconds' is not null or undefined
            assertParamExists('dboAPIGetCacheQueryInsights', 'stepSeconds', stepSeconds)
            const localVarPath = `/v1/dbo/cache-groups/{groupId}/cache-configurations/{cacheId}/queries/{templateHash}/insights`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"cacheId"}}`, encodeURIComponent(String(cacheId)))
                .replace(`{${"templateHash"}}`, encodeURIComponent(String(templateHash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (metricsRangeStart !== undefined) {
                localVarQueryParameter['metricsRange.start'] = (metricsRangeStart as any instanceof Date) ?
                    (metricsRangeStart as any).toISOString() :
                    metricsRangeStart;
            }

            if (metricsRangeEnd !== undefined) {
                localVarQueryParameter['metricsRange.end'] = (metricsRangeEnd as any instanceof Date) ?
                    (metricsRangeEnd as any).toISOString() :
                    metricsRangeEnd;
            }

            if (stepSeconds !== undefined) {
                localVarQueryParameter['stepSeconds'] = stepSeconds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the full query template string for the provided template hash.
         * @summary Get cache query template
         * @param {string} groupId 
         * @param {string} cacheId 
         * @param {string} templateHash 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheQueryTemplate: async (groupId: string, cacheId: string, templateHash: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('dboAPIGetCacheQueryTemplate', 'groupId', groupId)
            // verify required parameter 'cacheId' is not null or undefined
            assertParamExists('dboAPIGetCacheQueryTemplate', 'cacheId', cacheId)
            // verify required parameter 'templateHash' is not null or undefined
            assertParamExists('dboAPIGetCacheQueryTemplate', 'templateHash', templateHash)
            const localVarPath = `/v1/dbo/cache-groups/{groupId}/cache-configurations/{cacheId}/queries/{templateHash}/template`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"cacheId"}}`, encodeURIComponent(String(cacheId)))
                .replace(`{${"templateHash"}}`, encodeURIComponent(String(templateHash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves cache summary for the current organization.
         * @summary Get cache summary
         * @param {string} groupId 
         * @param {string} cacheId 
         * @param {string} [startTime] Start of period.
         * @param {string} [endTime] End of period.
         * @param {string} [username] Filter by username.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheSummary: async (groupId: string, cacheId: string, startTime?: string, endTime?: string, username?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('dboAPIGetCacheSummary', 'groupId', groupId)
            // verify required parameter 'cacheId' is not null or undefined
            assertParamExists('dboAPIGetCacheSummary', 'cacheId', cacheId)
            const localVarPath = `/v1/dbo/cache-groups/{groupId}/cache-configurations/{cacheId}/summary`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"cacheId"}}`, encodeURIComponent(String(cacheId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves database cluster details.
         * @summary Get database cluster details
         * @param {string} clusterId 
         * @param {string} [startTime] Start of period.
         * @param {string} [endTime] End of period.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetDatabaseCluster: async (clusterId: string, startTime?: string, endTime?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('dboAPIGetDatabaseCluster', 'clusterId', clusterId)
            const localVarPath = `/v1/dbo/db-clusters/{clusterId}`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves database instances details.
         * @summary Get database instance details
         * @param {string} instanceId 
         * @param {string} [startTime] Start of period.
         * @param {string} [endTime] End of period.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetDatabaseInstance: async (instanceId: string, startTime?: string, endTime?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('dboAPIGetDatabaseInstance', 'instanceId', instanceId)
            const localVarPath = `/v1/dbo/db-instances/{instanceId}`
                .replace(`{${"instanceId"}}`, encodeURIComponent(String(instanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves database instance infrastructure metrics.
         * @summary Get database instance infrastructure metrics
         * @param {string} instanceId 
         * @param {string} startTime Start of period.
         * @param {string} endTime End of period.
         * @param {number} stepSeconds Aggregate items in specified interval steps.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetDatabaseInstanceInfrastructureMetrics: async (instanceId: string, startTime: string, endTime: string, stepSeconds: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('dboAPIGetDatabaseInstanceInfrastructureMetrics', 'instanceId', instanceId)
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('dboAPIGetDatabaseInstanceInfrastructureMetrics', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('dboAPIGetDatabaseInstanceInfrastructureMetrics', 'endTime', endTime)
            // verify required parameter 'stepSeconds' is not null or undefined
            assertParamExists('dboAPIGetDatabaseInstanceInfrastructureMetrics', 'stepSeconds', stepSeconds)
            const localVarPath = `/v1/dbo/db-instances/{instanceId}/infrastructure-metrics`
                .replace(`{${"instanceId"}}`, encodeURIComponent(String(instanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (stepSeconds !== undefined) {
                localVarQueryParameter['stepSeconds'] = stepSeconds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns shell script to execute a registration
         * @param {string} registrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetRegistrationScript: async (registrationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registrationId' is not null or undefined
            assertParamExists('dboAPIGetRegistrationScript', 'registrationId', registrationId)
            const localVarPath = `/v1/dbo/registrations/{registrationId}/script`
                .replace(`{${"registrationId"}}`, encodeURIComponent(String(registrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get registration status.
         * @param {string} registrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetRegistrationStatus: async (registrationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registrationId' is not null or undefined
            assertParamExists('dboAPIGetRegistrationStatus', 'registrationId', registrationId)
            const localVarPath = `/v1/dbo/registrations/{registrationId}/status`
                .replace(`{${"registrationId"}}`, encodeURIComponent(String(registrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ingests operational metrics from proxy and query-processor.
         * @summary Ingest Operational Processor metrics
         * @param {DboV1OperationalMetrics} metrics 
         * @param {string} [instanceId] 
         * @param {string} [component] 
         * @param {string} [cacheGroupId] 
         * @param {string} [namespace] 
         * @param {string} [deployment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIIngestOperationalMetrics: async (metrics: DboV1OperationalMetrics, instanceId?: string, component?: string, cacheGroupId?: string, namespace?: string, deployment?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metrics' is not null or undefined
            assertParamExists('dboAPIIngestOperationalMetrics', 'metrics', metrics)
            const localVarPath = `/v1/dbo/query-processor/operational-metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (instanceId !== undefined) {
                localVarQueryParameter['instanceId'] = instanceId;
            }

            if (component !== undefined) {
                localVarQueryParameter['component'] = component;
            }

            if (cacheGroupId !== undefined) {
                localVarQueryParameter['cacheGroupId'] = cacheGroupId;
            }

            if (namespace !== undefined) {
                localVarQueryParameter['namespace'] = namespace;
            }

            if (deployment !== undefined) {
                localVarQueryParameter['deployment'] = deployment;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(metrics, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List onboarded cloud accounts.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIListAccounts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/dbo/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists cache configurations for a given cache group.
         * @summary List cache configurations
         * @param {string} groupId 
         * @param {string} [databaseName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIListCacheConfigurations: async (groupId: string, databaseName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('dboAPIListCacheConfigurations', 'groupId', groupId)
            const localVarPath = `/v1/dbo/cache-groups/{groupId}/cache-configurations`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseName !== undefined) {
                localVarQueryParameter['databaseName'] = databaseName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists cache groups in a given organization.
         * @summary List cache groups.
         * @param {string} [instanceId] 
         * @param {string} [clusterId] 
         * @param {string} [metricsRangeStart] Start of period.
         * @param {string} [metricsRangeEnd] End of period.
         * @param {boolean} [deployed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIListCacheGroups: async (instanceId?: string, clusterId?: string, metricsRangeStart?: string, metricsRangeEnd?: string, deployed?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/dbo/cache-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (instanceId !== undefined) {
                localVarQueryParameter['instanceId'] = instanceId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (metricsRangeStart !== undefined) {
                localVarQueryParameter['metricsRange.start'] = (metricsRangeStart as any instanceof Date) ?
                    (metricsRangeStart as any).toISOString() :
                    metricsRangeStart;
            }

            if (metricsRangeEnd !== undefined) {
                localVarQueryParameter['metricsRange.end'] = (metricsRangeEnd as any instanceof Date) ?
                    (metricsRangeEnd as any).toISOString() :
                    metricsRangeEnd;
            }

            if (deployed !== undefined) {
                localVarQueryParameter['deployed'] = deployed;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lightweight alternative to ListCacheGroups for service-to-service callers that only need the cache group identity and its configurations.
         * @summary List cache groups with their cache configurations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIListCacheGroupsWithConfigurations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/dbo/cache-groups-lite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists cache TTL configurations for a given cache configuration.
         * @summary List cache TTL configurations
         * @param {string} groupId 
         * @param {string} cacheId 
         * @param {string} [table] 
         * @param {string} [templateHash] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIListCacheTTLs: async (groupId: string, cacheId: string, table?: string, templateHash?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('dboAPIListCacheTTLs', 'groupId', groupId)
            // verify required parameter 'cacheId' is not null or undefined
            assertParamExists('dboAPIListCacheTTLs', 'cacheId', cacheId)
            const localVarPath = `/v1/dbo/cache-groups/{groupId}/cache-configurations/{cacheId}/rules`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"cacheId"}}`, encodeURIComponent(String(cacheId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (table !== undefined) {
                localVarQueryParameter['table'] = table;
            }

            if (templateHash !== undefined) {
                localVarQueryParameter['templateHash'] = templateHash;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists database components for the current organization.
         * @summary List database components
         * @param {string} [startTime] Start of period.
         * @param {string} [endTime] End of period.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIListDatabaseComponents: async (startTime?: string, endTime?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/dbo/db-components`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates cache configuration.
         * @summary Updates cache configuration
         * @param {string} groupId 
         * @param {string} id 
         * @param {DboV1CacheConfiguration} config 
         * @param {boolean} [roxy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIUpdateCacheConfiguration: async (groupId: string, id: string, config: DboV1CacheConfiguration, roxy?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('dboAPIUpdateCacheConfiguration', 'groupId', groupId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dboAPIUpdateCacheConfiguration', 'id', id)
            // verify required parameter 'config' is not null or undefined
            assertParamExists('dboAPIUpdateCacheConfiguration', 'config', config)
            const localVarPath = `/v1/dbo/cache-groups/{groupId}/cache-configurations/{id}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (roxy !== undefined) {
                localVarQueryParameter['roxy'] = roxy;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(config, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates cache group.
         * @summary Update cache group.
         * @param {string} id 
         * @param {DboV1CacheGroup} group 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIUpdateCacheGroup: async (id: string, group: DboV1CacheGroup, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dboAPIUpdateCacheGroup', 'id', id)
            // verify required parameter 'group' is not null or undefined
            assertParamExists('dboAPIUpdateCacheGroup', 'group', group)
            const localVarPath = `/v1/dbo/cache-groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(group, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates TTL cache configuration.
         * @summary Updates TTL cache configuration
         * @param {string} groupId 
         * @param {string} cacheId 
         * @param {string} id 
         * @param {DboV1TTLConfiguration} config 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIUpdateCacheTTL: async (groupId: string, cacheId: string, id: string, config: DboV1TTLConfiguration, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('dboAPIUpdateCacheTTL', 'groupId', groupId)
            // verify required parameter 'cacheId' is not null or undefined
            assertParamExists('dboAPIUpdateCacheTTL', 'cacheId', cacheId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dboAPIUpdateCacheTTL', 'id', id)
            // verify required parameter 'config' is not null or undefined
            assertParamExists('dboAPIUpdateCacheTTL', 'config', config)
            const localVarPath = `/v1/dbo/cache-groups/{groupId}/cache-configurations/{cacheId}/rules/{id}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"cacheId"}}`, encodeURIComponent(String(cacheId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(config, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DboAPIApi - functional programming interface
 * @export
 */
export const DboAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DboAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates new cache configuration in a given cache group.
         * @summary Create cache configuration
         * @param {string} groupId 
         * @param {DboV1CacheConfiguration} config 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPICreateCacheConfiguration(groupId: string, config: DboV1CacheConfiguration, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1CacheConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPICreateCacheConfiguration(groupId, config, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPICreateCacheConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates an ephemeral upload URL for a diagnostics file
         * @summary Create upload URL for diagnostic file
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPICreateCacheDiagnosticUploadURL(groupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1CreateCacheDiagnosticUploadURLResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPICreateCacheDiagnosticUploadURL(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPICreateCacheDiagnosticUploadURL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates new cache group.
         * @summary Create cache group.
         * @param {DboV1CacheGroup} group 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPICreateCacheGroup(group: DboV1CacheGroup, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1CacheGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPICreateCacheGroup(group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPICreateCacheGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates new cache TTL configuration.
         * @summary Create cache TTL configuration
         * @param {string} groupId 
         * @param {string} id 
         * @param {DboV1TTLConfiguration} config 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPICreateCacheTTL(groupId: string, id: string, config: DboV1TTLConfiguration, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1TTLConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPICreateCacheTTL(groupId, id, config, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPICreateCacheTTL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create new registration.
         * @param {DboV1Registration} registration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPICreateRegistration(registration: DboV1Registration, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1Registration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPICreateRegistration(registration, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPICreateRegistration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create registration status update.
         * @param {string} registrationId 
         * @param {DboV1RegistrationStatusUpdate} statusUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPICreateRegistrationStatusUpdate(registrationId: string, statusUpdate: DboV1RegistrationStatusUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPICreateRegistrationStatusUpdate(registrationId, statusUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPICreateRegistrationStatusUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes cache configuration.
         * @summary Deletes cache configuration
         * @param {string} groupId 
         * @param {string} id 
         * @param {boolean} [roxy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIDeleteCacheConfiguration(groupId: string, id: string, roxy?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIDeleteCacheConfiguration(groupId, id, roxy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIDeleteCacheConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a given cache group.
         * @summary Deletes cache group.
         * @param {string} id 
         * @param {boolean} [roxy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIDeleteCacheGroup(id: string, roxy?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIDeleteCacheGroup(id, roxy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIDeleteCacheGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes TTL cache configuration.
         * @summary Deletes TTL cache configuration
         * @param {string} groupId 
         * @param {string} cacheId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIDeleteCacheTTL(groupId: string, cacheId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIDeleteCacheTTL(groupId, cacheId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIDeleteCacheTTL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * State/config exchange between a proxy instance and CAST AI control plane.
         * @summary State exchange
         * @param {string} cacheGroupId 
         * @param {DboV1ProxyState} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIExchangeCacheState(cacheGroupId: string, state: DboV1ProxyState, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1ExchangeCacheStateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIExchangeCacheState(cacheGroupId, state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIExchangeCacheState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a cache configuration for a given cache group and database name
         * @summary Get cache configuration
         * @param {string} groupId 
         * @param {string} databaseName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIGetCacheConfiguration(groupId: string, databaseName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1GetCacheConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIGetCacheConfiguration(groupId, databaseName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIGetCacheConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves cache efficiency.
         * @summary Get cache efficiency data.
         * @param {string} groupId 
         * @param {string} cacheId 
         * @param {string} startTime Start of period.
         * @param {string} endTime End of period.
         * @param {number} stepSeconds Aggregate items in specified interval steps.
         * @param {string} [templateHash] Optionally filter the results by a specific template hash
         * @param {string} [username] Filter by username.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIGetCacheEfficiency(groupId: string, cacheId: string, startTime: string, endTime: string, stepSeconds: number, templateHash?: string, username?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1GetCacheEfficiencyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIGetCacheEfficiency(groupId, cacheId, startTime, endTime, stepSeconds, templateHash, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIGetCacheEfficiency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns cache group by ID.
         * @summary Get cache group.
         * @param {string} id 
         * @param {string} [metricsRangeStart] Start of period.
         * @param {string} [metricsRangeEnd] End of period.
         * @param {boolean} [roxy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIGetCacheGroup(id: string, metricsRangeStart?: string, metricsRangeEnd?: string, roxy?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1CacheGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIGetCacheGroup(id, metricsRangeStart, metricsRangeEnd, roxy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIGetCacheGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves available filter options (e.g., users) for cache group metrics.
         * @summary Get cache group metrics filter options
         * @param {string} id 
         * @param {string} [timeRangeStart] Start of period.
         * @param {string} [timeRangeEnd] End of period.
         * @param {string} [databaseId] Filter by specific database (cache configuration) ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIGetCacheGroupMetricsFilterOptions(id: string, timeRangeStart?: string, timeRangeEnd?: string, databaseId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1GetCacheGroupMetricsFilterOptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIGetCacheGroupMetricsFilterOptions(id, timeRangeStart, timeRangeEnd, databaseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIGetCacheGroupMetricsFilterOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves cache group operational metrics timeseries data.
         * @summary Get cache group operational metrics
         * @param {string} id 
         * @param {number} stepSeconds Aggregate items in specified interval steps.
         * @param {string} [metricsRangeStart] Start of period.
         * @param {string} [metricsRangeEnd] End of period.
         * @param {string} [configurationId] Cache configuration id: if provided, will filter by it.
         * @param {string} [endpointName] Filter by endpoint name. Cannot be combined with username.
         * @param {string} [username] Filter by username. Cannot be combined with endpoint_name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIGetCacheGroupOperationalMetrics(id: string, stepSeconds: number, metricsRangeStart?: string, metricsRangeEnd?: string, configurationId?: string, endpointName?: string, username?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1GetCacheGroupOperationalMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIGetCacheGroupOperationalMetrics(id, stepSeconds, metricsRangeStart, metricsRangeEnd, configurationId, endpointName, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIGetCacheGroupOperationalMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves cache group performance timeseries data.
         * @summary Get cache group performance
         * @param {string} id 
         * @param {string} startTime Start of period.
         * @param {string} endTime End of period.
         * @param {number} stepSeconds Aggregate items in specified interval steps.
         * @param {string} [databaseId] Filter by specific database (cache configuration) ID.
         * @param {string} [endpointName] Filter by endpoint name. Cannot be combined with username.
         * @param {string} [username] Filter by username. Cannot be combined with endpoint_name.
         * @param {boolean} [roxy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIGetCacheGroupPerformance(id: string, startTime: string, endTime: string, stepSeconds: number, databaseId?: string, endpointName?: string, username?: string, roxy?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1GetCacheGroupPerformanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIGetCacheGroupPerformance(id, startTime, endTime, stepSeconds, databaseId, endpointName, username, roxy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIGetCacheGroupPerformance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves aggregated cache performance metrics for a cache group.
         * @summary Get cache group performance summary
         * @param {string} id 
         * @param {string} [metricsRangeStart] Start of period.
         * @param {string} [metricsRangeEnd] End of period.
         * @param {string} [databaseId] Filter by specific database (cache configuration) ID.
         * @param {string} [endpointName] Filter by endpoint name. Cannot be combined with username.
         * @param {string} [username] Filter by username. Cannot be combined with endpoint_name.
         * @param {boolean} [roxy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIGetCacheGroupPerformanceSummary(id: string, metricsRangeStart?: string, metricsRangeEnd?: string, databaseId?: string, endpointName?: string, username?: string, roxy?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1GetCacheGroupPerformanceSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIGetCacheGroupPerformanceSummary(id, metricsRangeStart, metricsRangeEnd, databaseId, endpointName, username, roxy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIGetCacheGroupPerformanceSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves cache group operational metrics timeseries data.
         * @summary Get cache group pooling eligibility report
         * @param {string} id Cache Group ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIGetCacheGroupPoolingEligibility(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1GetCacheGroupPoolingEligibilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIGetCacheGroupPoolingEligibility(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIGetCacheGroupPoolingEligibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves cache queries for the current organization.
         * @summary Get cache queries
         * @param {string} groupId 
         * @param {string} cacheId 
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] Name of the field you want to sort
         * @param {DboAPIGetCacheQueriesSortOrderEnum} [sortOrder] The sort order, possible values ASC or DESC, if not provided asc is the default   - ASC: ASC  - asc: desc  - DESC: ASC  - desc: desc
         * @param {string} [startTime] Start of period.
         * @param {string} [endTime] End of period.
         * @param {string} [queryContains] An optional parameter for performing substring matching on the query template string.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIGetCacheQueries(groupId: string, cacheId: string, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: DboAPIGetCacheQueriesSortOrderEnum, startTime?: string, endTime?: string, queryContains?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1GetCacheQueriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIGetCacheQueries(groupId, cacheId, pageLimit, pageCursor, sortField, sortOrder, startTime, endTime, queryContains, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIGetCacheQueries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves cache query for the current organization by its template hash.
         * @summary Get cache query
         * @param {string} groupId 
         * @param {string} cacheId 
         * @param {string} templateHash 
         * @param {string} [metricsRangeStart] Start of period.
         * @param {string} [metricsRangeEnd] End of period.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIGetCacheQuery(groupId: string, cacheId: string, templateHash: string, metricsRangeStart?: string, metricsRangeEnd?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1CacheQuery>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIGetCacheQuery(groupId, cacheId, templateHash, metricsRangeStart, metricsRangeEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIGetCacheQuery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves detailed query insights such as cache miss latency, TTL values, and unique parameter counts over time.
         * @summary Get cache query insights
         * @param {string} groupId 
         * @param {string} cacheId 
         * @param {string} templateHash 
         * @param {number} stepSeconds 
         * @param {string} [metricsRangeStart] Start of period.
         * @param {string} [metricsRangeEnd] End of period.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIGetCacheQueryInsights(groupId: string, cacheId: string, templateHash: string, stepSeconds: number, metricsRangeStart?: string, metricsRangeEnd?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1GetCacheQueryInsightsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIGetCacheQueryInsights(groupId, cacheId, templateHash, stepSeconds, metricsRangeStart, metricsRangeEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIGetCacheQueryInsights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the full query template string for the provided template hash.
         * @summary Get cache query template
         * @param {string} groupId 
         * @param {string} cacheId 
         * @param {string} templateHash 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIGetCacheQueryTemplate(groupId: string, cacheId: string, templateHash: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1GetCacheQueryTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIGetCacheQueryTemplate(groupId, cacheId, templateHash, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIGetCacheQueryTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves cache summary for the current organization.
         * @summary Get cache summary
         * @param {string} groupId 
         * @param {string} cacheId 
         * @param {string} [startTime] Start of period.
         * @param {string} [endTime] End of period.
         * @param {string} [username] Filter by username.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIGetCacheSummary(groupId: string, cacheId: string, startTime?: string, endTime?: string, username?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1GetCacheSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIGetCacheSummary(groupId, cacheId, startTime, endTime, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIGetCacheSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves database cluster details.
         * @summary Get database cluster details
         * @param {string} clusterId 
         * @param {string} [startTime] Start of period.
         * @param {string} [endTime] End of period.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIGetDatabaseCluster(clusterId: string, startTime?: string, endTime?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1DatabaseCluster>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIGetDatabaseCluster(clusterId, startTime, endTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIGetDatabaseCluster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves database instances details.
         * @summary Get database instance details
         * @param {string} instanceId 
         * @param {string} [startTime] Start of period.
         * @param {string} [endTime] End of period.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIGetDatabaseInstance(instanceId: string, startTime?: string, endTime?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1DatabaseInstance>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIGetDatabaseInstance(instanceId, startTime, endTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIGetDatabaseInstance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves database instance infrastructure metrics.
         * @summary Get database instance infrastructure metrics
         * @param {string} instanceId 
         * @param {string} startTime Start of period.
         * @param {string} endTime End of period.
         * @param {number} stepSeconds Aggregate items in specified interval steps.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIGetDatabaseInstanceInfrastructureMetrics(instanceId: string, startTime: string, endTime: string, stepSeconds: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DboV1InstanceMetrics>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIGetDatabaseInstanceInfrastructureMetrics(instanceId, startTime, endTime, stepSeconds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIGetDatabaseInstanceInfrastructureMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns shell script to execute a registration
         * @param {string} registrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIGetRegistrationScript(registrationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleApiHttpBody>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIGetRegistrationScript(registrationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIGetRegistrationScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get registration status.
         * @param {string} registrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIGetRegistrationStatus(registrationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1RegistrationStatusUpdate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIGetRegistrationStatus(registrationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIGetRegistrationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ingests operational metrics from proxy and query-processor.
         * @summary Ingest Operational Processor metrics
         * @param {DboV1OperationalMetrics} metrics 
         * @param {string} [instanceId] 
         * @param {string} [component] 
         * @param {string} [cacheGroupId] 
         * @param {string} [namespace] 
         * @param {string} [deployment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIIngestOperationalMetrics(metrics: DboV1OperationalMetrics, instanceId?: string, component?: string, cacheGroupId?: string, namespace?: string, deployment?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIIngestOperationalMetrics(metrics, instanceId, component, cacheGroupId, namespace, deployment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIIngestOperationalMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List onboarded cloud accounts.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIListAccounts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DboV1Account>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIListAccounts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIListAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists cache configurations for a given cache group.
         * @summary List cache configurations
         * @param {string} groupId 
         * @param {string} [databaseName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIListCacheConfigurations(groupId: string, databaseName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1ListCacheConfigurationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIListCacheConfigurations(groupId, databaseName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIListCacheConfigurations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists cache groups in a given organization.
         * @summary List cache groups.
         * @param {string} [instanceId] 
         * @param {string} [clusterId] 
         * @param {string} [metricsRangeStart] Start of period.
         * @param {string} [metricsRangeEnd] End of period.
         * @param {boolean} [deployed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIListCacheGroups(instanceId?: string, clusterId?: string, metricsRangeStart?: string, metricsRangeEnd?: string, deployed?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1ListCacheGroupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIListCacheGroups(instanceId, clusterId, metricsRangeStart, metricsRangeEnd, deployed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIListCacheGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lightweight alternative to ListCacheGroups for service-to-service callers that only need the cache group identity and its configurations.
         * @summary List cache groups with their cache configurations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIListCacheGroupsWithConfigurations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1ListCacheGroupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIListCacheGroupsWithConfigurations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIListCacheGroupsWithConfigurations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists cache TTL configurations for a given cache configuration.
         * @summary List cache TTL configurations
         * @param {string} groupId 
         * @param {string} cacheId 
         * @param {string} [table] 
         * @param {string} [templateHash] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIListCacheTTLs(groupId: string, cacheId: string, table?: string, templateHash?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1ListCacheTTLsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIListCacheTTLs(groupId, cacheId, table, templateHash, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIListCacheTTLs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists database components for the current organization.
         * @summary List database components
         * @param {string} [startTime] Start of period.
         * @param {string} [endTime] End of period.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIListDatabaseComponents(startTime?: string, endTime?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1ListDatabaseComponentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIListDatabaseComponents(startTime, endTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIListDatabaseComponents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates cache configuration.
         * @summary Updates cache configuration
         * @param {string} groupId 
         * @param {string} id 
         * @param {DboV1CacheConfiguration} config 
         * @param {boolean} [roxy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIUpdateCacheConfiguration(groupId: string, id: string, config: DboV1CacheConfiguration, roxy?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1CacheConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIUpdateCacheConfiguration(groupId, id, config, roxy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIUpdateCacheConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates cache group.
         * @summary Update cache group.
         * @param {string} id 
         * @param {DboV1CacheGroup} group 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIUpdateCacheGroup(id: string, group: DboV1CacheGroup, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1CacheGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIUpdateCacheGroup(id, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIUpdateCacheGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates TTL cache configuration.
         * @summary Updates TTL cache configuration
         * @param {string} groupId 
         * @param {string} cacheId 
         * @param {string} id 
         * @param {DboV1TTLConfiguration} config 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dboAPIUpdateCacheTTL(groupId: string, cacheId: string, id: string, config: DboV1TTLConfiguration, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DboV1TTLConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dboAPIUpdateCacheTTL(groupId, cacheId, id, config, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DboAPIApi.dboAPIUpdateCacheTTL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DboAPIApi - factory interface
 * @export
 */
export const DboAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DboAPIApiFp(configuration)
    return {
        /**
         * Creates new cache configuration in a given cache group.
         * @summary Create cache configuration
         * @param {DboAPIApiDboAPICreateCacheConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPICreateCacheConfiguration(requestParameters: DboAPIApiDboAPICreateCacheConfigurationRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1CacheConfiguration> {
            return localVarFp.dboAPICreateCacheConfiguration(requestParameters.groupId, requestParameters.config, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates an ephemeral upload URL for a diagnostics file
         * @summary Create upload URL for diagnostic file
         * @param {DboAPIApiDboAPICreateCacheDiagnosticUploadURLRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPICreateCacheDiagnosticUploadURL(requestParameters: DboAPIApiDboAPICreateCacheDiagnosticUploadURLRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1CreateCacheDiagnosticUploadURLResponse> {
            return localVarFp.dboAPICreateCacheDiagnosticUploadURL(requestParameters.groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates new cache group.
         * @summary Create cache group.
         * @param {DboAPIApiDboAPICreateCacheGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPICreateCacheGroup(requestParameters: DboAPIApiDboAPICreateCacheGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1CacheGroup> {
            return localVarFp.dboAPICreateCacheGroup(requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates new cache TTL configuration.
         * @summary Create cache TTL configuration
         * @param {DboAPIApiDboAPICreateCacheTTLRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPICreateCacheTTL(requestParameters: DboAPIApiDboAPICreateCacheTTLRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1TTLConfiguration> {
            return localVarFp.dboAPICreateCacheTTL(requestParameters.groupId, requestParameters.id, requestParameters.config, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new registration.
         * @param {DboAPIApiDboAPICreateRegistrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPICreateRegistration(requestParameters: DboAPIApiDboAPICreateRegistrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1Registration> {
            return localVarFp.dboAPICreateRegistration(requestParameters.registration, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create registration status update.
         * @param {DboAPIApiDboAPICreateRegistrationStatusUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPICreateRegistrationStatusUpdate(requestParameters: DboAPIApiDboAPICreateRegistrationStatusUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.dboAPICreateRegistrationStatusUpdate(requestParameters.registrationId, requestParameters.statusUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes cache configuration.
         * @summary Deletes cache configuration
         * @param {DboAPIApiDboAPIDeleteCacheConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIDeleteCacheConfiguration(requestParameters: DboAPIApiDboAPIDeleteCacheConfigurationRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.dboAPIDeleteCacheConfiguration(requestParameters.groupId, requestParameters.id, requestParameters.roxy, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a given cache group.
         * @summary Deletes cache group.
         * @param {DboAPIApiDboAPIDeleteCacheGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIDeleteCacheGroup(requestParameters: DboAPIApiDboAPIDeleteCacheGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.dboAPIDeleteCacheGroup(requestParameters.id, requestParameters.roxy, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes TTL cache configuration.
         * @summary Deletes TTL cache configuration
         * @param {DboAPIApiDboAPIDeleteCacheTTLRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIDeleteCacheTTL(requestParameters: DboAPIApiDboAPIDeleteCacheTTLRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.dboAPIDeleteCacheTTL(requestParameters.groupId, requestParameters.cacheId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * State/config exchange between a proxy instance and CAST AI control plane.
         * @summary State exchange
         * @param {DboAPIApiDboAPIExchangeCacheStateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIExchangeCacheState(requestParameters: DboAPIApiDboAPIExchangeCacheStateRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1ExchangeCacheStateResponse> {
            return localVarFp.dboAPIExchangeCacheState(requestParameters.cacheGroupId, requestParameters.state, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a cache configuration for a given cache group and database name
         * @summary Get cache configuration
         * @param {DboAPIApiDboAPIGetCacheConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheConfiguration(requestParameters: DboAPIApiDboAPIGetCacheConfigurationRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1GetCacheConfigurationResponse> {
            return localVarFp.dboAPIGetCacheConfiguration(requestParameters.groupId, requestParameters.databaseName, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves cache efficiency.
         * @summary Get cache efficiency data.
         * @param {DboAPIApiDboAPIGetCacheEfficiencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheEfficiency(requestParameters: DboAPIApiDboAPIGetCacheEfficiencyRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1GetCacheEfficiencyResponse> {
            return localVarFp.dboAPIGetCacheEfficiency(requestParameters.groupId, requestParameters.cacheId, requestParameters.startTime, requestParameters.endTime, requestParameters.stepSeconds, requestParameters.templateHash, requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns cache group by ID.
         * @summary Get cache group.
         * @param {DboAPIApiDboAPIGetCacheGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheGroup(requestParameters: DboAPIApiDboAPIGetCacheGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1CacheGroup> {
            return localVarFp.dboAPIGetCacheGroup(requestParameters.id, requestParameters.metricsRangeStart, requestParameters.metricsRangeEnd, requestParameters.roxy, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves available filter options (e.g., users) for cache group metrics.
         * @summary Get cache group metrics filter options
         * @param {DboAPIApiDboAPIGetCacheGroupMetricsFilterOptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheGroupMetricsFilterOptions(requestParameters: DboAPIApiDboAPIGetCacheGroupMetricsFilterOptionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1GetCacheGroupMetricsFilterOptionsResponse> {
            return localVarFp.dboAPIGetCacheGroupMetricsFilterOptions(requestParameters.id, requestParameters.timeRangeStart, requestParameters.timeRangeEnd, requestParameters.databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves cache group operational metrics timeseries data.
         * @summary Get cache group operational metrics
         * @param {DboAPIApiDboAPIGetCacheGroupOperationalMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheGroupOperationalMetrics(requestParameters: DboAPIApiDboAPIGetCacheGroupOperationalMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1GetCacheGroupOperationalMetricsResponse> {
            return localVarFp.dboAPIGetCacheGroupOperationalMetrics(requestParameters.id, requestParameters.stepSeconds, requestParameters.metricsRangeStart, requestParameters.metricsRangeEnd, requestParameters.configurationId, requestParameters.endpointName, requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves cache group performance timeseries data.
         * @summary Get cache group performance
         * @param {DboAPIApiDboAPIGetCacheGroupPerformanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheGroupPerformance(requestParameters: DboAPIApiDboAPIGetCacheGroupPerformanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1GetCacheGroupPerformanceResponse> {
            return localVarFp.dboAPIGetCacheGroupPerformance(requestParameters.id, requestParameters.startTime, requestParameters.endTime, requestParameters.stepSeconds, requestParameters.databaseId, requestParameters.endpointName, requestParameters.username, requestParameters.roxy, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves aggregated cache performance metrics for a cache group.
         * @summary Get cache group performance summary
         * @param {DboAPIApiDboAPIGetCacheGroupPerformanceSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheGroupPerformanceSummary(requestParameters: DboAPIApiDboAPIGetCacheGroupPerformanceSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1GetCacheGroupPerformanceSummaryResponse> {
            return localVarFp.dboAPIGetCacheGroupPerformanceSummary(requestParameters.id, requestParameters.metricsRangeStart, requestParameters.metricsRangeEnd, requestParameters.databaseId, requestParameters.endpointName, requestParameters.username, requestParameters.roxy, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves cache group operational metrics timeseries data.
         * @summary Get cache group pooling eligibility report
         * @param {DboAPIApiDboAPIGetCacheGroupPoolingEligibilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheGroupPoolingEligibility(requestParameters: DboAPIApiDboAPIGetCacheGroupPoolingEligibilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1GetCacheGroupPoolingEligibilityResponse> {
            return localVarFp.dboAPIGetCacheGroupPoolingEligibility(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves cache queries for the current organization.
         * @summary Get cache queries
         * @param {DboAPIApiDboAPIGetCacheQueriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheQueries(requestParameters: DboAPIApiDboAPIGetCacheQueriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1GetCacheQueriesResponse> {
            return localVarFp.dboAPIGetCacheQueries(requestParameters.groupId, requestParameters.cacheId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, requestParameters.startTime, requestParameters.endTime, requestParameters.queryContains, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves cache query for the current organization by its template hash.
         * @summary Get cache query
         * @param {DboAPIApiDboAPIGetCacheQueryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheQuery(requestParameters: DboAPIApiDboAPIGetCacheQueryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1CacheQuery> {
            return localVarFp.dboAPIGetCacheQuery(requestParameters.groupId, requestParameters.cacheId, requestParameters.templateHash, requestParameters.metricsRangeStart, requestParameters.metricsRangeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves detailed query insights such as cache miss latency, TTL values, and unique parameter counts over time.
         * @summary Get cache query insights
         * @param {DboAPIApiDboAPIGetCacheQueryInsightsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheQueryInsights(requestParameters: DboAPIApiDboAPIGetCacheQueryInsightsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1GetCacheQueryInsightsResponse> {
            return localVarFp.dboAPIGetCacheQueryInsights(requestParameters.groupId, requestParameters.cacheId, requestParameters.templateHash, requestParameters.stepSeconds, requestParameters.metricsRangeStart, requestParameters.metricsRangeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the full query template string for the provided template hash.
         * @summary Get cache query template
         * @param {DboAPIApiDboAPIGetCacheQueryTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheQueryTemplate(requestParameters: DboAPIApiDboAPIGetCacheQueryTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1GetCacheQueryTemplateResponse> {
            return localVarFp.dboAPIGetCacheQueryTemplate(requestParameters.groupId, requestParameters.cacheId, requestParameters.templateHash, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves cache summary for the current organization.
         * @summary Get cache summary
         * @param {DboAPIApiDboAPIGetCacheSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetCacheSummary(requestParameters: DboAPIApiDboAPIGetCacheSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1GetCacheSummaryResponse> {
            return localVarFp.dboAPIGetCacheSummary(requestParameters.groupId, requestParameters.cacheId, requestParameters.startTime, requestParameters.endTime, requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves database cluster details.
         * @summary Get database cluster details
         * @param {DboAPIApiDboAPIGetDatabaseClusterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetDatabaseCluster(requestParameters: DboAPIApiDboAPIGetDatabaseClusterRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1DatabaseCluster> {
            return localVarFp.dboAPIGetDatabaseCluster(requestParameters.clusterId, requestParameters.startTime, requestParameters.endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves database instances details.
         * @summary Get database instance details
         * @param {DboAPIApiDboAPIGetDatabaseInstanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetDatabaseInstance(requestParameters: DboAPIApiDboAPIGetDatabaseInstanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1DatabaseInstance> {
            return localVarFp.dboAPIGetDatabaseInstance(requestParameters.instanceId, requestParameters.startTime, requestParameters.endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves database instance infrastructure metrics.
         * @summary Get database instance infrastructure metrics
         * @param {DboAPIApiDboAPIGetDatabaseInstanceInfrastructureMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetDatabaseInstanceInfrastructureMetrics(requestParameters: DboAPIApiDboAPIGetDatabaseInstanceInfrastructureMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<DboV1InstanceMetrics>> {
            return localVarFp.dboAPIGetDatabaseInstanceInfrastructureMetrics(requestParameters.instanceId, requestParameters.startTime, requestParameters.endTime, requestParameters.stepSeconds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns shell script to execute a registration
         * @param {DboAPIApiDboAPIGetRegistrationScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetRegistrationScript(requestParameters: DboAPIApiDboAPIGetRegistrationScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<GoogleApiHttpBody> {
            return localVarFp.dboAPIGetRegistrationScript(requestParameters.registrationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get registration status.
         * @param {DboAPIApiDboAPIGetRegistrationStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIGetRegistrationStatus(requestParameters: DboAPIApiDboAPIGetRegistrationStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1RegistrationStatusUpdate> {
            return localVarFp.dboAPIGetRegistrationStatus(requestParameters.registrationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Ingests operational metrics from proxy and query-processor.
         * @summary Ingest Operational Processor metrics
         * @param {DboAPIApiDboAPIIngestOperationalMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIIngestOperationalMetrics(requestParameters: DboAPIApiDboAPIIngestOperationalMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.dboAPIIngestOperationalMetrics(requestParameters.metrics, requestParameters.instanceId, requestParameters.component, requestParameters.cacheGroupId, requestParameters.namespace, requestParameters.deployment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List onboarded cloud accounts.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIListAccounts(options?: RawAxiosRequestConfig): AxiosPromise<Array<DboV1Account>> {
            return localVarFp.dboAPIListAccounts(options).then((request) => request(axios, basePath));
        },
        /**
         * Lists cache configurations for a given cache group.
         * @summary List cache configurations
         * @param {DboAPIApiDboAPIListCacheConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIListCacheConfigurations(requestParameters: DboAPIApiDboAPIListCacheConfigurationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1ListCacheConfigurationsResponse> {
            return localVarFp.dboAPIListCacheConfigurations(requestParameters.groupId, requestParameters.databaseName, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists cache groups in a given organization.
         * @summary List cache groups.
         * @param {DboAPIApiDboAPIListCacheGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIListCacheGroups(requestParameters: DboAPIApiDboAPIListCacheGroupsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DboV1ListCacheGroupsResponse> {
            return localVarFp.dboAPIListCacheGroups(requestParameters.instanceId, requestParameters.clusterId, requestParameters.metricsRangeStart, requestParameters.metricsRangeEnd, requestParameters.deployed, options).then((request) => request(axios, basePath));
        },
        /**
         * Lightweight alternative to ListCacheGroups for service-to-service callers that only need the cache group identity and its configurations.
         * @summary List cache groups with their cache configurations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIListCacheGroupsWithConfigurations(options?: RawAxiosRequestConfig): AxiosPromise<DboV1ListCacheGroupsResponse> {
            return localVarFp.dboAPIListCacheGroupsWithConfigurations(options).then((request) => request(axios, basePath));
        },
        /**
         * Lists cache TTL configurations for a given cache configuration.
         * @summary List cache TTL configurations
         * @param {DboAPIApiDboAPIListCacheTTLsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIListCacheTTLs(requestParameters: DboAPIApiDboAPIListCacheTTLsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1ListCacheTTLsResponse> {
            return localVarFp.dboAPIListCacheTTLs(requestParameters.groupId, requestParameters.cacheId, requestParameters.table, requestParameters.templateHash, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists database components for the current organization.
         * @summary List database components
         * @param {DboAPIApiDboAPIListDatabaseComponentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIListDatabaseComponents(requestParameters: DboAPIApiDboAPIListDatabaseComponentsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DboV1ListDatabaseComponentsResponse> {
            return localVarFp.dboAPIListDatabaseComponents(requestParameters.startTime, requestParameters.endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates cache configuration.
         * @summary Updates cache configuration
         * @param {DboAPIApiDboAPIUpdateCacheConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIUpdateCacheConfiguration(requestParameters: DboAPIApiDboAPIUpdateCacheConfigurationRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1CacheConfiguration> {
            return localVarFp.dboAPIUpdateCacheConfiguration(requestParameters.groupId, requestParameters.id, requestParameters.config, requestParameters.roxy, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates cache group.
         * @summary Update cache group.
         * @param {DboAPIApiDboAPIUpdateCacheGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIUpdateCacheGroup(requestParameters: DboAPIApiDboAPIUpdateCacheGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1CacheGroup> {
            return localVarFp.dboAPIUpdateCacheGroup(requestParameters.id, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates TTL cache configuration.
         * @summary Updates TTL cache configuration
         * @param {DboAPIApiDboAPIUpdateCacheTTLRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dboAPIUpdateCacheTTL(requestParameters: DboAPIApiDboAPIUpdateCacheTTLRequest, options?: RawAxiosRequestConfig): AxiosPromise<DboV1TTLConfiguration> {
            return localVarFp.dboAPIUpdateCacheTTL(requestParameters.groupId, requestParameters.cacheId, requestParameters.id, requestParameters.config, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for dboAPICreateCacheConfiguration operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPICreateCacheConfigurationRequest
 */
export interface DboAPIApiDboAPICreateCacheConfigurationRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPICreateCacheConfiguration
     */
    readonly groupId: string

    /**
     * 
     * @type {DboV1CacheConfiguration}
     * @memberof DboAPIApiDboAPICreateCacheConfiguration
     */
    readonly config: DboV1CacheConfiguration
}

/**
 * Request parameters for dboAPICreateCacheDiagnosticUploadURL operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPICreateCacheDiagnosticUploadURLRequest
 */
export interface DboAPIApiDboAPICreateCacheDiagnosticUploadURLRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPICreateCacheDiagnosticUploadURL
     */
    readonly groupId: string
}

/**
 * Request parameters for dboAPICreateCacheGroup operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPICreateCacheGroupRequest
 */
export interface DboAPIApiDboAPICreateCacheGroupRequest {
    /**
     * 
     * @type {DboV1CacheGroup}
     * @memberof DboAPIApiDboAPICreateCacheGroup
     */
    readonly group: DboV1CacheGroup
}

/**
 * Request parameters for dboAPICreateCacheTTL operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPICreateCacheTTLRequest
 */
export interface DboAPIApiDboAPICreateCacheTTLRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPICreateCacheTTL
     */
    readonly groupId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPICreateCacheTTL
     */
    readonly id: string

    /**
     * 
     * @type {DboV1TTLConfiguration}
     * @memberof DboAPIApiDboAPICreateCacheTTL
     */
    readonly config: DboV1TTLConfiguration
}

/**
 * Request parameters for dboAPICreateRegistration operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPICreateRegistrationRequest
 */
export interface DboAPIApiDboAPICreateRegistrationRequest {
    /**
     * 
     * @type {DboV1Registration}
     * @memberof DboAPIApiDboAPICreateRegistration
     */
    readonly registration: DboV1Registration
}

/**
 * Request parameters for dboAPICreateRegistrationStatusUpdate operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPICreateRegistrationStatusUpdateRequest
 */
export interface DboAPIApiDboAPICreateRegistrationStatusUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPICreateRegistrationStatusUpdate
     */
    readonly registrationId: string

    /**
     * 
     * @type {DboV1RegistrationStatusUpdate}
     * @memberof DboAPIApiDboAPICreateRegistrationStatusUpdate
     */
    readonly statusUpdate: DboV1RegistrationStatusUpdate
}

/**
 * Request parameters for dboAPIDeleteCacheConfiguration operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIDeleteCacheConfigurationRequest
 */
export interface DboAPIApiDboAPIDeleteCacheConfigurationRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIDeleteCacheConfiguration
     */
    readonly groupId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIDeleteCacheConfiguration
     */
    readonly id: string

    /**
     * 
     * @type {boolean}
     * @memberof DboAPIApiDboAPIDeleteCacheConfiguration
     */
    readonly roxy?: boolean
}

/**
 * Request parameters for dboAPIDeleteCacheGroup operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIDeleteCacheGroupRequest
 */
export interface DboAPIApiDboAPIDeleteCacheGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIDeleteCacheGroup
     */
    readonly id: string

    /**
     * 
     * @type {boolean}
     * @memberof DboAPIApiDboAPIDeleteCacheGroup
     */
    readonly roxy?: boolean
}

/**
 * Request parameters for dboAPIDeleteCacheTTL operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIDeleteCacheTTLRequest
 */
export interface DboAPIApiDboAPIDeleteCacheTTLRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIDeleteCacheTTL
     */
    readonly groupId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIDeleteCacheTTL
     */
    readonly cacheId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIDeleteCacheTTL
     */
    readonly id: string
}

/**
 * Request parameters for dboAPIExchangeCacheState operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIExchangeCacheStateRequest
 */
export interface DboAPIApiDboAPIExchangeCacheStateRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIExchangeCacheState
     */
    readonly cacheGroupId: string

    /**
     * 
     * @type {DboV1ProxyState}
     * @memberof DboAPIApiDboAPIExchangeCacheState
     */
    readonly state: DboV1ProxyState
}

/**
 * Request parameters for dboAPIGetCacheConfiguration operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIGetCacheConfigurationRequest
 */
export interface DboAPIApiDboAPIGetCacheConfigurationRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheConfiguration
     */
    readonly groupId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheConfiguration
     */
    readonly databaseName: string
}

/**
 * Request parameters for dboAPIGetCacheEfficiency operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIGetCacheEfficiencyRequest
 */
export interface DboAPIApiDboAPIGetCacheEfficiencyRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheEfficiency
     */
    readonly groupId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheEfficiency
     */
    readonly cacheId: string

    /**
     * Start of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheEfficiency
     */
    readonly startTime: string

    /**
     * End of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheEfficiency
     */
    readonly endTime: string

    /**
     * Aggregate items in specified interval steps.
     * @type {number}
     * @memberof DboAPIApiDboAPIGetCacheEfficiency
     */
    readonly stepSeconds: number

    /**
     * Optionally filter the results by a specific template hash
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheEfficiency
     */
    readonly templateHash?: string

    /**
     * Filter by username.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheEfficiency
     */
    readonly username?: string
}

/**
 * Request parameters for dboAPIGetCacheGroup operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIGetCacheGroupRequest
 */
export interface DboAPIApiDboAPIGetCacheGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroup
     */
    readonly id: string

    /**
     * Start of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroup
     */
    readonly metricsRangeStart?: string

    /**
     * End of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroup
     */
    readonly metricsRangeEnd?: string

    /**
     * 
     * @type {boolean}
     * @memberof DboAPIApiDboAPIGetCacheGroup
     */
    readonly roxy?: boolean
}

/**
 * Request parameters for dboAPIGetCacheGroupMetricsFilterOptions operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIGetCacheGroupMetricsFilterOptionsRequest
 */
export interface DboAPIApiDboAPIGetCacheGroupMetricsFilterOptionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupMetricsFilterOptions
     */
    readonly id: string

    /**
     * Start of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupMetricsFilterOptions
     */
    readonly timeRangeStart?: string

    /**
     * End of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupMetricsFilterOptions
     */
    readonly timeRangeEnd?: string

    /**
     * Filter by specific database (cache configuration) ID.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupMetricsFilterOptions
     */
    readonly databaseId?: string
}

/**
 * Request parameters for dboAPIGetCacheGroupOperationalMetrics operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIGetCacheGroupOperationalMetricsRequest
 */
export interface DboAPIApiDboAPIGetCacheGroupOperationalMetricsRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupOperationalMetrics
     */
    readonly id: string

    /**
     * Aggregate items in specified interval steps.
     * @type {number}
     * @memberof DboAPIApiDboAPIGetCacheGroupOperationalMetrics
     */
    readonly stepSeconds: number

    /**
     * Start of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupOperationalMetrics
     */
    readonly metricsRangeStart?: string

    /**
     * End of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupOperationalMetrics
     */
    readonly metricsRangeEnd?: string

    /**
     * Cache configuration id: if provided, will filter by it.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupOperationalMetrics
     */
    readonly configurationId?: string

    /**
     * Filter by endpoint name. Cannot be combined with username.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupOperationalMetrics
     */
    readonly endpointName?: string

    /**
     * Filter by username. Cannot be combined with endpoint_name.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupOperationalMetrics
     */
    readonly username?: string
}

/**
 * Request parameters for dboAPIGetCacheGroupPerformance operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIGetCacheGroupPerformanceRequest
 */
export interface DboAPIApiDboAPIGetCacheGroupPerformanceRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupPerformance
     */
    readonly id: string

    /**
     * Start of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupPerformance
     */
    readonly startTime: string

    /**
     * End of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupPerformance
     */
    readonly endTime: string

    /**
     * Aggregate items in specified interval steps.
     * @type {number}
     * @memberof DboAPIApiDboAPIGetCacheGroupPerformance
     */
    readonly stepSeconds: number

    /**
     * Filter by specific database (cache configuration) ID.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupPerformance
     */
    readonly databaseId?: string

    /**
     * Filter by endpoint name. Cannot be combined with username.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupPerformance
     */
    readonly endpointName?: string

    /**
     * Filter by username. Cannot be combined with endpoint_name.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupPerformance
     */
    readonly username?: string

    /**
     * 
     * @type {boolean}
     * @memberof DboAPIApiDboAPIGetCacheGroupPerformance
     */
    readonly roxy?: boolean
}

/**
 * Request parameters for dboAPIGetCacheGroupPerformanceSummary operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIGetCacheGroupPerformanceSummaryRequest
 */
export interface DboAPIApiDboAPIGetCacheGroupPerformanceSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupPerformanceSummary
     */
    readonly id: string

    /**
     * Start of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupPerformanceSummary
     */
    readonly metricsRangeStart?: string

    /**
     * End of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupPerformanceSummary
     */
    readonly metricsRangeEnd?: string

    /**
     * Filter by specific database (cache configuration) ID.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupPerformanceSummary
     */
    readonly databaseId?: string

    /**
     * Filter by endpoint name. Cannot be combined with username.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupPerformanceSummary
     */
    readonly endpointName?: string

    /**
     * Filter by username. Cannot be combined with endpoint_name.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupPerformanceSummary
     */
    readonly username?: string

    /**
     * 
     * @type {boolean}
     * @memberof DboAPIApiDboAPIGetCacheGroupPerformanceSummary
     */
    readonly roxy?: boolean
}

/**
 * Request parameters for dboAPIGetCacheGroupPoolingEligibility operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIGetCacheGroupPoolingEligibilityRequest
 */
export interface DboAPIApiDboAPIGetCacheGroupPoolingEligibilityRequest {
    /**
     * Cache Group ID
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheGroupPoolingEligibility
     */
    readonly id: string
}

/**
 * Request parameters for dboAPIGetCacheQueries operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIGetCacheQueriesRequest
 */
export interface DboAPIApiDboAPIGetCacheQueriesRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQueries
     */
    readonly groupId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQueries
     */
    readonly cacheId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQueries
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQueries
     */
    readonly pageCursor?: string

    /**
     * Name of the field you want to sort
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQueries
     */
    readonly sortField?: string

    /**
     * The sort order, possible values ASC or DESC, if not provided asc is the default   - ASC: ASC  - asc: desc  - DESC: ASC  - desc: desc
     * @type {'ASC' | 'asc' | 'DESC' | 'desc'}
     * @memberof DboAPIApiDboAPIGetCacheQueries
     */
    readonly sortOrder?: DboAPIGetCacheQueriesSortOrderEnum

    /**
     * Start of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQueries
     */
    readonly startTime?: string

    /**
     * End of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQueries
     */
    readonly endTime?: string

    /**
     * An optional parameter for performing substring matching on the query template string.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQueries
     */
    readonly queryContains?: string
}

/**
 * Request parameters for dboAPIGetCacheQuery operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIGetCacheQueryRequest
 */
export interface DboAPIApiDboAPIGetCacheQueryRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQuery
     */
    readonly groupId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQuery
     */
    readonly cacheId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQuery
     */
    readonly templateHash: string

    /**
     * Start of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQuery
     */
    readonly metricsRangeStart?: string

    /**
     * End of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQuery
     */
    readonly metricsRangeEnd?: string
}

/**
 * Request parameters for dboAPIGetCacheQueryInsights operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIGetCacheQueryInsightsRequest
 */
export interface DboAPIApiDboAPIGetCacheQueryInsightsRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQueryInsights
     */
    readonly groupId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQueryInsights
     */
    readonly cacheId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQueryInsights
     */
    readonly templateHash: string

    /**
     * 
     * @type {number}
     * @memberof DboAPIApiDboAPIGetCacheQueryInsights
     */
    readonly stepSeconds: number

    /**
     * Start of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQueryInsights
     */
    readonly metricsRangeStart?: string

    /**
     * End of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQueryInsights
     */
    readonly metricsRangeEnd?: string
}

/**
 * Request parameters for dboAPIGetCacheQueryTemplate operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIGetCacheQueryTemplateRequest
 */
export interface DboAPIApiDboAPIGetCacheQueryTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQueryTemplate
     */
    readonly groupId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQueryTemplate
     */
    readonly cacheId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheQueryTemplate
     */
    readonly templateHash: string
}

/**
 * Request parameters for dboAPIGetCacheSummary operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIGetCacheSummaryRequest
 */
export interface DboAPIApiDboAPIGetCacheSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheSummary
     */
    readonly groupId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheSummary
     */
    readonly cacheId: string

    /**
     * Start of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheSummary
     */
    readonly startTime?: string

    /**
     * End of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheSummary
     */
    readonly endTime?: string

    /**
     * Filter by username.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetCacheSummary
     */
    readonly username?: string
}

/**
 * Request parameters for dboAPIGetDatabaseCluster operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIGetDatabaseClusterRequest
 */
export interface DboAPIApiDboAPIGetDatabaseClusterRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetDatabaseCluster
     */
    readonly clusterId: string

    /**
     * Start of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetDatabaseCluster
     */
    readonly startTime?: string

    /**
     * End of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetDatabaseCluster
     */
    readonly endTime?: string
}

/**
 * Request parameters for dboAPIGetDatabaseInstance operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIGetDatabaseInstanceRequest
 */
export interface DboAPIApiDboAPIGetDatabaseInstanceRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetDatabaseInstance
     */
    readonly instanceId: string

    /**
     * Start of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetDatabaseInstance
     */
    readonly startTime?: string

    /**
     * End of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetDatabaseInstance
     */
    readonly endTime?: string
}

/**
 * Request parameters for dboAPIGetDatabaseInstanceInfrastructureMetrics operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIGetDatabaseInstanceInfrastructureMetricsRequest
 */
export interface DboAPIApiDboAPIGetDatabaseInstanceInfrastructureMetricsRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetDatabaseInstanceInfrastructureMetrics
     */
    readonly instanceId: string

    /**
     * Start of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetDatabaseInstanceInfrastructureMetrics
     */
    readonly startTime: string

    /**
     * End of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIGetDatabaseInstanceInfrastructureMetrics
     */
    readonly endTime: string

    /**
     * Aggregate items in specified interval steps.
     * @type {number}
     * @memberof DboAPIApiDboAPIGetDatabaseInstanceInfrastructureMetrics
     */
    readonly stepSeconds: number
}

/**
 * Request parameters for dboAPIGetRegistrationScript operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIGetRegistrationScriptRequest
 */
export interface DboAPIApiDboAPIGetRegistrationScriptRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetRegistrationScript
     */
    readonly registrationId: string
}

/**
 * Request parameters for dboAPIGetRegistrationStatus operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIGetRegistrationStatusRequest
 */
export interface DboAPIApiDboAPIGetRegistrationStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIGetRegistrationStatus
     */
    readonly registrationId: string
}

/**
 * Request parameters for dboAPIIngestOperationalMetrics operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIIngestOperationalMetricsRequest
 */
export interface DboAPIApiDboAPIIngestOperationalMetricsRequest {
    /**
     * 
     * @type {DboV1OperationalMetrics}
     * @memberof DboAPIApiDboAPIIngestOperationalMetrics
     */
    readonly metrics: DboV1OperationalMetrics

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIIngestOperationalMetrics
     */
    readonly instanceId?: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIIngestOperationalMetrics
     */
    readonly component?: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIIngestOperationalMetrics
     */
    readonly cacheGroupId?: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIIngestOperationalMetrics
     */
    readonly namespace?: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIIngestOperationalMetrics
     */
    readonly deployment?: string
}

/**
 * Request parameters for dboAPIListCacheConfigurations operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIListCacheConfigurationsRequest
 */
export interface DboAPIApiDboAPIListCacheConfigurationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIListCacheConfigurations
     */
    readonly groupId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIListCacheConfigurations
     */
    readonly databaseName?: string
}

/**
 * Request parameters for dboAPIListCacheGroups operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIListCacheGroupsRequest
 */
export interface DboAPIApiDboAPIListCacheGroupsRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIListCacheGroups
     */
    readonly instanceId?: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIListCacheGroups
     */
    readonly clusterId?: string

    /**
     * Start of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIListCacheGroups
     */
    readonly metricsRangeStart?: string

    /**
     * End of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIListCacheGroups
     */
    readonly metricsRangeEnd?: string

    /**
     * 
     * @type {boolean}
     * @memberof DboAPIApiDboAPIListCacheGroups
     */
    readonly deployed?: boolean
}

/**
 * Request parameters for dboAPIListCacheTTLs operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIListCacheTTLsRequest
 */
export interface DboAPIApiDboAPIListCacheTTLsRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIListCacheTTLs
     */
    readonly groupId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIListCacheTTLs
     */
    readonly cacheId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIListCacheTTLs
     */
    readonly table?: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIListCacheTTLs
     */
    readonly templateHash?: string
}

/**
 * Request parameters for dboAPIListDatabaseComponents operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIListDatabaseComponentsRequest
 */
export interface DboAPIApiDboAPIListDatabaseComponentsRequest {
    /**
     * Start of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIListDatabaseComponents
     */
    readonly startTime?: string

    /**
     * End of period.
     * @type {string}
     * @memberof DboAPIApiDboAPIListDatabaseComponents
     */
    readonly endTime?: string
}

/**
 * Request parameters for dboAPIUpdateCacheConfiguration operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIUpdateCacheConfigurationRequest
 */
export interface DboAPIApiDboAPIUpdateCacheConfigurationRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIUpdateCacheConfiguration
     */
    readonly groupId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIUpdateCacheConfiguration
     */
    readonly id: string

    /**
     * 
     * @type {DboV1CacheConfiguration}
     * @memberof DboAPIApiDboAPIUpdateCacheConfiguration
     */
    readonly config: DboV1CacheConfiguration

    /**
     * 
     * @type {boolean}
     * @memberof DboAPIApiDboAPIUpdateCacheConfiguration
     */
    readonly roxy?: boolean
}

/**
 * Request parameters for dboAPIUpdateCacheGroup operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIUpdateCacheGroupRequest
 */
export interface DboAPIApiDboAPIUpdateCacheGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIUpdateCacheGroup
     */
    readonly id: string

    /**
     * 
     * @type {DboV1CacheGroup}
     * @memberof DboAPIApiDboAPIUpdateCacheGroup
     */
    readonly group: DboV1CacheGroup
}

/**
 * Request parameters for dboAPIUpdateCacheTTL operation in DboAPIApi.
 * @export
 * @interface DboAPIApiDboAPIUpdateCacheTTLRequest
 */
export interface DboAPIApiDboAPIUpdateCacheTTLRequest {
    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIUpdateCacheTTL
     */
    readonly groupId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIUpdateCacheTTL
     */
    readonly cacheId: string

    /**
     * 
     * @type {string}
     * @memberof DboAPIApiDboAPIUpdateCacheTTL
     */
    readonly id: string

    /**
     * 
     * @type {DboV1TTLConfiguration}
     * @memberof DboAPIApiDboAPIUpdateCacheTTL
     */
    readonly config: DboV1TTLConfiguration
}

/**
 * DboAPIApi - object-oriented interface
 * @export
 * @class DboAPIApi
 * @extends {BaseAPI}
 */
export class DboAPIApi extends BaseAPI {
    /**
     * Creates new cache configuration in a given cache group.
     * @summary Create cache configuration
     * @param {DboAPIApiDboAPICreateCacheConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPICreateCacheConfiguration(requestParameters: DboAPIApiDboAPICreateCacheConfigurationRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPICreateCacheConfiguration(requestParameters.groupId, requestParameters.config, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates an ephemeral upload URL for a diagnostics file
     * @summary Create upload URL for diagnostic file
     * @param {DboAPIApiDboAPICreateCacheDiagnosticUploadURLRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPICreateCacheDiagnosticUploadURL(requestParameters: DboAPIApiDboAPICreateCacheDiagnosticUploadURLRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPICreateCacheDiagnosticUploadURL(requestParameters.groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates new cache group.
     * @summary Create cache group.
     * @param {DboAPIApiDboAPICreateCacheGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPICreateCacheGroup(requestParameters: DboAPIApiDboAPICreateCacheGroupRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPICreateCacheGroup(requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates new cache TTL configuration.
     * @summary Create cache TTL configuration
     * @param {DboAPIApiDboAPICreateCacheTTLRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPICreateCacheTTL(requestParameters: DboAPIApiDboAPICreateCacheTTLRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPICreateCacheTTL(requestParameters.groupId, requestParameters.id, requestParameters.config, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new registration.
     * @param {DboAPIApiDboAPICreateRegistrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPICreateRegistration(requestParameters: DboAPIApiDboAPICreateRegistrationRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPICreateRegistration(requestParameters.registration, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create registration status update.
     * @param {DboAPIApiDboAPICreateRegistrationStatusUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPICreateRegistrationStatusUpdate(requestParameters: DboAPIApiDboAPICreateRegistrationStatusUpdateRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPICreateRegistrationStatusUpdate(requestParameters.registrationId, requestParameters.statusUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes cache configuration.
     * @summary Deletes cache configuration
     * @param {DboAPIApiDboAPIDeleteCacheConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIDeleteCacheConfiguration(requestParameters: DboAPIApiDboAPIDeleteCacheConfigurationRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIDeleteCacheConfiguration(requestParameters.groupId, requestParameters.id, requestParameters.roxy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a given cache group.
     * @summary Deletes cache group.
     * @param {DboAPIApiDboAPIDeleteCacheGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIDeleteCacheGroup(requestParameters: DboAPIApiDboAPIDeleteCacheGroupRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIDeleteCacheGroup(requestParameters.id, requestParameters.roxy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes TTL cache configuration.
     * @summary Deletes TTL cache configuration
     * @param {DboAPIApiDboAPIDeleteCacheTTLRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIDeleteCacheTTL(requestParameters: DboAPIApiDboAPIDeleteCacheTTLRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIDeleteCacheTTL(requestParameters.groupId, requestParameters.cacheId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * State/config exchange between a proxy instance and CAST AI control plane.
     * @summary State exchange
     * @param {DboAPIApiDboAPIExchangeCacheStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIExchangeCacheState(requestParameters: DboAPIApiDboAPIExchangeCacheStateRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIExchangeCacheState(requestParameters.cacheGroupId, requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a cache configuration for a given cache group and database name
     * @summary Get cache configuration
     * @param {DboAPIApiDboAPIGetCacheConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIGetCacheConfiguration(requestParameters: DboAPIApiDboAPIGetCacheConfigurationRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIGetCacheConfiguration(requestParameters.groupId, requestParameters.databaseName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves cache efficiency.
     * @summary Get cache efficiency data.
     * @param {DboAPIApiDboAPIGetCacheEfficiencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIGetCacheEfficiency(requestParameters: DboAPIApiDboAPIGetCacheEfficiencyRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIGetCacheEfficiency(requestParameters.groupId, requestParameters.cacheId, requestParameters.startTime, requestParameters.endTime, requestParameters.stepSeconds, requestParameters.templateHash, requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns cache group by ID.
     * @summary Get cache group.
     * @param {DboAPIApiDboAPIGetCacheGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIGetCacheGroup(requestParameters: DboAPIApiDboAPIGetCacheGroupRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIGetCacheGroup(requestParameters.id, requestParameters.metricsRangeStart, requestParameters.metricsRangeEnd, requestParameters.roxy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves available filter options (e.g., users) for cache group metrics.
     * @summary Get cache group metrics filter options
     * @param {DboAPIApiDboAPIGetCacheGroupMetricsFilterOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIGetCacheGroupMetricsFilterOptions(requestParameters: DboAPIApiDboAPIGetCacheGroupMetricsFilterOptionsRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIGetCacheGroupMetricsFilterOptions(requestParameters.id, requestParameters.timeRangeStart, requestParameters.timeRangeEnd, requestParameters.databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves cache group operational metrics timeseries data.
     * @summary Get cache group operational metrics
     * @param {DboAPIApiDboAPIGetCacheGroupOperationalMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIGetCacheGroupOperationalMetrics(requestParameters: DboAPIApiDboAPIGetCacheGroupOperationalMetricsRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIGetCacheGroupOperationalMetrics(requestParameters.id, requestParameters.stepSeconds, requestParameters.metricsRangeStart, requestParameters.metricsRangeEnd, requestParameters.configurationId, requestParameters.endpointName, requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves cache group performance timeseries data.
     * @summary Get cache group performance
     * @param {DboAPIApiDboAPIGetCacheGroupPerformanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIGetCacheGroupPerformance(requestParameters: DboAPIApiDboAPIGetCacheGroupPerformanceRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIGetCacheGroupPerformance(requestParameters.id, requestParameters.startTime, requestParameters.endTime, requestParameters.stepSeconds, requestParameters.databaseId, requestParameters.endpointName, requestParameters.username, requestParameters.roxy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves aggregated cache performance metrics for a cache group.
     * @summary Get cache group performance summary
     * @param {DboAPIApiDboAPIGetCacheGroupPerformanceSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIGetCacheGroupPerformanceSummary(requestParameters: DboAPIApiDboAPIGetCacheGroupPerformanceSummaryRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIGetCacheGroupPerformanceSummary(requestParameters.id, requestParameters.metricsRangeStart, requestParameters.metricsRangeEnd, requestParameters.databaseId, requestParameters.endpointName, requestParameters.username, requestParameters.roxy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves cache group operational metrics timeseries data.
     * @summary Get cache group pooling eligibility report
     * @param {DboAPIApiDboAPIGetCacheGroupPoolingEligibilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIGetCacheGroupPoolingEligibility(requestParameters: DboAPIApiDboAPIGetCacheGroupPoolingEligibilityRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIGetCacheGroupPoolingEligibility(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves cache queries for the current organization.
     * @summary Get cache queries
     * @param {DboAPIApiDboAPIGetCacheQueriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIGetCacheQueries(requestParameters: DboAPIApiDboAPIGetCacheQueriesRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIGetCacheQueries(requestParameters.groupId, requestParameters.cacheId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, requestParameters.startTime, requestParameters.endTime, requestParameters.queryContains, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves cache query for the current organization by its template hash.
     * @summary Get cache query
     * @param {DboAPIApiDboAPIGetCacheQueryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIGetCacheQuery(requestParameters: DboAPIApiDboAPIGetCacheQueryRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIGetCacheQuery(requestParameters.groupId, requestParameters.cacheId, requestParameters.templateHash, requestParameters.metricsRangeStart, requestParameters.metricsRangeEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves detailed query insights such as cache miss latency, TTL values, and unique parameter counts over time.
     * @summary Get cache query insights
     * @param {DboAPIApiDboAPIGetCacheQueryInsightsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIGetCacheQueryInsights(requestParameters: DboAPIApiDboAPIGetCacheQueryInsightsRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIGetCacheQueryInsights(requestParameters.groupId, requestParameters.cacheId, requestParameters.templateHash, requestParameters.stepSeconds, requestParameters.metricsRangeStart, requestParameters.metricsRangeEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the full query template string for the provided template hash.
     * @summary Get cache query template
     * @param {DboAPIApiDboAPIGetCacheQueryTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIGetCacheQueryTemplate(requestParameters: DboAPIApiDboAPIGetCacheQueryTemplateRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIGetCacheQueryTemplate(requestParameters.groupId, requestParameters.cacheId, requestParameters.templateHash, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves cache summary for the current organization.
     * @summary Get cache summary
     * @param {DboAPIApiDboAPIGetCacheSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIGetCacheSummary(requestParameters: DboAPIApiDboAPIGetCacheSummaryRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIGetCacheSummary(requestParameters.groupId, requestParameters.cacheId, requestParameters.startTime, requestParameters.endTime, requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves database cluster details.
     * @summary Get database cluster details
     * @param {DboAPIApiDboAPIGetDatabaseClusterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIGetDatabaseCluster(requestParameters: DboAPIApiDboAPIGetDatabaseClusterRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIGetDatabaseCluster(requestParameters.clusterId, requestParameters.startTime, requestParameters.endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves database instances details.
     * @summary Get database instance details
     * @param {DboAPIApiDboAPIGetDatabaseInstanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIGetDatabaseInstance(requestParameters: DboAPIApiDboAPIGetDatabaseInstanceRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIGetDatabaseInstance(requestParameters.instanceId, requestParameters.startTime, requestParameters.endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves database instance infrastructure metrics.
     * @summary Get database instance infrastructure metrics
     * @param {DboAPIApiDboAPIGetDatabaseInstanceInfrastructureMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIGetDatabaseInstanceInfrastructureMetrics(requestParameters: DboAPIApiDboAPIGetDatabaseInstanceInfrastructureMetricsRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIGetDatabaseInstanceInfrastructureMetrics(requestParameters.instanceId, requestParameters.startTime, requestParameters.endTime, requestParameters.stepSeconds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns shell script to execute a registration
     * @param {DboAPIApiDboAPIGetRegistrationScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIGetRegistrationScript(requestParameters: DboAPIApiDboAPIGetRegistrationScriptRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIGetRegistrationScript(requestParameters.registrationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get registration status.
     * @param {DboAPIApiDboAPIGetRegistrationStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIGetRegistrationStatus(requestParameters: DboAPIApiDboAPIGetRegistrationStatusRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIGetRegistrationStatus(requestParameters.registrationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ingests operational metrics from proxy and query-processor.
     * @summary Ingest Operational Processor metrics
     * @param {DboAPIApiDboAPIIngestOperationalMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIIngestOperationalMetrics(requestParameters: DboAPIApiDboAPIIngestOperationalMetricsRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIIngestOperationalMetrics(requestParameters.metrics, requestParameters.instanceId, requestParameters.component, requestParameters.cacheGroupId, requestParameters.namespace, requestParameters.deployment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List onboarded cloud accounts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIListAccounts(options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIListAccounts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists cache configurations for a given cache group.
     * @summary List cache configurations
     * @param {DboAPIApiDboAPIListCacheConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIListCacheConfigurations(requestParameters: DboAPIApiDboAPIListCacheConfigurationsRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIListCacheConfigurations(requestParameters.groupId, requestParameters.databaseName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists cache groups in a given organization.
     * @summary List cache groups.
     * @param {DboAPIApiDboAPIListCacheGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIListCacheGroups(requestParameters: DboAPIApiDboAPIListCacheGroupsRequest = {}, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIListCacheGroups(requestParameters.instanceId, requestParameters.clusterId, requestParameters.metricsRangeStart, requestParameters.metricsRangeEnd, requestParameters.deployed, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lightweight alternative to ListCacheGroups for service-to-service callers that only need the cache group identity and its configurations.
     * @summary List cache groups with their cache configurations.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIListCacheGroupsWithConfigurations(options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIListCacheGroupsWithConfigurations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists cache TTL configurations for a given cache configuration.
     * @summary List cache TTL configurations
     * @param {DboAPIApiDboAPIListCacheTTLsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIListCacheTTLs(requestParameters: DboAPIApiDboAPIListCacheTTLsRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIListCacheTTLs(requestParameters.groupId, requestParameters.cacheId, requestParameters.table, requestParameters.templateHash, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists database components for the current organization.
     * @summary List database components
     * @param {DboAPIApiDboAPIListDatabaseComponentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIListDatabaseComponents(requestParameters: DboAPIApiDboAPIListDatabaseComponentsRequest = {}, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIListDatabaseComponents(requestParameters.startTime, requestParameters.endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates cache configuration.
     * @summary Updates cache configuration
     * @param {DboAPIApiDboAPIUpdateCacheConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIUpdateCacheConfiguration(requestParameters: DboAPIApiDboAPIUpdateCacheConfigurationRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIUpdateCacheConfiguration(requestParameters.groupId, requestParameters.id, requestParameters.config, requestParameters.roxy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates cache group.
     * @summary Update cache group.
     * @param {DboAPIApiDboAPIUpdateCacheGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIUpdateCacheGroup(requestParameters: DboAPIApiDboAPIUpdateCacheGroupRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIUpdateCacheGroup(requestParameters.id, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates TTL cache configuration.
     * @summary Updates TTL cache configuration
     * @param {DboAPIApiDboAPIUpdateCacheTTLRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DboAPIApi
     */
    public dboAPIUpdateCacheTTL(requestParameters: DboAPIApiDboAPIUpdateCacheTTLRequest, options?: RawAxiosRequestConfig) {
        return DboAPIApiFp(this.configuration).dboAPIUpdateCacheTTL(requestParameters.groupId, requestParameters.cacheId, requestParameters.id, requestParameters.config, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const DboAPIGetCacheQueriesSortOrderEnum = {
    ASC: 'ASC',
    asc: 'asc',
    DESC: 'DESC',
    desc: 'desc'
} as const;
export type DboAPIGetCacheQueriesSortOrderEnum = typeof DboAPIGetCacheQueriesSortOrderEnum[keyof typeof DboAPIGetCacheQueriesSortOrderEnum];
